import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { ClearButtonProps } from './interfaces';
import classNames from 'classnames';
import './ClearButton.scss';

export const ClearButton: React.FC<ClearButtonProps> = ({ className, onClick, dataTestId = 'clear-button' }) => {
    return (
        <FaTimes
            data-testid={dataTestId}
            className={classNames('ui-clear-button', className)}
            onClick={onClick}
        />
    );
};
